

import * as Debug from "debug";


const Cookies = require('js-cookie');


export class  Legend {
    
    debug = Debug('CRMMap:Legend');

    apicall:any;
    map:any;

    stage:number = 0;
    cookies:boolean;

    element = document.createElement("div");
    mappos = null;
 


    constructor(apicall, map, defaultStage = 1, cookies = true) {
        this.apicall = apicall;
        this.map = map;

        this.stage = 0;
        this.cookies = cookies;

        this.element.classList.add('legend');
        this.mappos = null;
        this.setMapPos(google.maps.ControlPosition.RIGHT_BOTTOM);
       
        if (this.cookies ) {
            this.setstage(Cookies.get('Legend') || defaultStage);
        } else {
            this.setstage(defaultStage);
        }
       
        this.element.innerHTML = "";      
        this.update();
    }

    setMapPos(mappos ) {
         if ( this.mappos) {
           // this.map.controls[this.mappos].removeAt(6);
           this.map.controls[this.mappos].forEach((T, index)=>{
               if (T.classList.contains('legend')) {
                this.map.controls[this.mappos].removeAt(index);
               }

           });
            this.mappos= null;
        }

        this.mappos = mappos;
        this.map.controls[this.mappos].push(this.element);
    }


    setstage(stage) {
        this.debug("Stage",this.stage, stage);
        this.element.classList.remove('state' + this.stage);
        this.stage = stage;
        this.element.classList.add('state' + this.stage);
        this.setMapPos(this.mappos);
    }

    nextStage() {
        var stage =  this.stage + 1;
        if ( stage > 4) {
            stage = 1;
        }

       
       this.setstage( stage);
       if (this.cookies) {
        Cookies.set('Legend', this.stage);
       }

    }

    update() {
        return this.apicall('/company/legend', false, 'GET', [], true).then((data) => {
            if (!(typeof data === 'string' || data instanceof String)) {
                this.debug("Did not get a string");
                data = "";
            }

            if (data.length <= 0) {
                this.element.style.display = 'none';
                return data;
            }

            this.element.innerHTML = data;
            //this.setMapPos(this.mappos);
            
            this.element.querySelectorAll('.focus').forEach(function(item) {
                item.addEventListener('click', (event) => {
                    this.debug('----');

                    event.preventDefault();
                    return false;

                });
            });
           
        });
    }

   updatefilter () {
    this.debug('updatefilter');


   }


    jsready() {
        this.element.addEventListener('click', (es) => {
            var e = <HTMLElement> es.target;
            
            while (e) {
            

            if (e.classList.contains('lheader')) {
                this.nextStage();
                return true;
            }

            if (e.classList.contains('list-group-item')) {
             //   e.classList.toggle('active');
             //   this.updatefilter();
                return true;
            }

            e = e.parentElement;
        }
           
           
        }, true);


    }

}


